import { render, staticRenderFns } from "./view_edit.vue?vue&type=template&id=e67bca18&scoped=true"
import script from "./view_edit.vue?vue&type=script&lang=js"
export * from "./view_edit.vue?vue&type=script&lang=js"
import style0 from "./view_edit.vue?vue&type=style&index=0&id=e67bca18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67bca18",
  null
  
)

export default component.exports